import { render, staticRenderFns } from "./onSubFormRowDelete-editor.vue?vue&type=template&id=c3bc5096&scoped=true"
import script from "./onSubFormRowDelete-editor.vue?vue&type=script&lang=js"
export * from "./onSubFormRowDelete-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3bc5096",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3bc5096')) {
      api.createRecord('c3bc5096', component.options)
    } else {
      api.reload('c3bc5096', component.options)
    }
    module.hot.accept("./onSubFormRowDelete-editor.vue?vue&type=template&id=c3bc5096&scoped=true", function () {
      api.rerender('c3bc5096', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/event-handler/onSubFormRowDelete-editor.vue"
export default component.exports